import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 3 }

import { computed, reactive, ref } from 'vue'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { AccountActivationItem, AccountActivationParams } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash-es'
import {
  newClientEvaluationDelete,
  newClientEvaluationList,
  newClientEvaluationRetract
} from '@/api/overseasSales/newClientEvaluation'
import { useRouter } from 'vue-router'
import Modal from '@/hooks/modalType'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'

const __default__ = { name: 'DcCosOFbuAccountActivationPage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const { t } = useI18n()
const router = useRouter()
const getList = (queryForm: AccountActivationParams, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  const arkCodeList = params.arkCode?.split(/[,，\s\n]/).filter((e: string) => e)
  if (arkCodeList && arkCodeList.length > 0) {
    params.arkCodeList = arkCodeList
    delete params.arkCode
  }
  const customerNumberList = params.customerNumber?.split(/[,，\s\n]/).filter((e: string) => e)
  if (customerNumberList && customerNumberList.length > 0) {
    params.customerNumberList = customerNumberList
    delete params.customerNumber
  }
  newClientEvaluationList(params).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: AccountActivationItem, callBack: (res: any) => void) => {
  if (!record.cosId) {
    return
  }
  salesClueDetail({ clueId: record.cosId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 激活客户提交审核
const handleAccountActivationSubmitReview = (row?: AccountActivationItem) => {
  if (!row) return
  router.push({ path: '/ofbu/accountActivation/edit', query: { accountActivationId: row.id, cosId: row.cosId, review: '1' } })
}
// 草稿编辑
const handleAccountActivationDraft = (row?: AccountActivationItem) => {
  if (!row) return
  router.push({ path: '/ofbu/accountActivation/edit', query: { draftId: row.id, cosId: row.cosId } })
}
// 新客评审删除
const handleAccountActivationDelete = (row?: AccountActivationItem) => {
  if (!row) return
  Modal.delete({
    content: t('tips.OADelete'),
    onOk() {
      newClientEvaluationDelete({ id: row.id }).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value?.delFetch()
      })
    }
  })
}
// 新客评审撤回
const handleAccountActivationRecall = (row?: AccountActivationItem) => {
  if (!row) return
  DcConfirm.warning({
    cancelText: t('btn.cancel'),
    content: t('tips.OARevoke'),
    okText: t('btn.sure'),
    onOk() {
      newClientEvaluationRetract({ id: row.id }).then(() => {
        message.success(t('tips.revokeSuccess'))
        tableRef.value?.search()
      })
    }
  })
}
const tableRef = ref()
const queryForm = reactive<AccountActivationParams>({ auditStatus: '20', applyType: 2 })
const statusEnum = computed(() =>
  oaReviewStatus.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
)
const columns = computed(() => [
  {
    title: t('custom.customerName'),
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: t('custom.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('custom.arkCode'), dataIndex: 'arkCode' },
  { title: t('custom.客户创建时间'), dataIndex: 'customerCreateTime', width: 190 },
  { title: t('custom.followerName'), dataIndex: 'sellerName' },
  { title: t('custom.申请单号'), dataIndex: 'applyNo' },
  { title: t('custom.流程创建人'), dataIndex: 'applicantName' },
  { title: t('custom.流程创建时间'), dataIndex: 'applyTime', width: 190 },
  { title: t('custom.当前审核人'), dataIndex: 'nextReviewer' },
  { title: t('custom.审核状态'), dataIndex: 'auditStatus' },
  { title: t('custom.当前审核意见'), dataIndex: 'reviewComments' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 260,
      en: 280
    },
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_dc_layout_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_cos_table, {
                serial: "",
                rowKey: "clientId",
                columns: columns.value,
                search: queryForm,
                "onUpdate:search": _cache[11] || (_cache[11] = ($event: any) => ((queryForm) = $event)),
                onFetch: getList,
                onMask: showMask,
                ref_key: "tableRef",
                ref: tableRef,
                tableId: "DcCosOFbuAccountActivation"
              }, {
                search: _withCtx(() => [
                  _createVNode(_component_a_form, { model: queryForm }, {
                    default: _withCtx(() => [
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.审核状态')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosSelect, {
                            value: queryForm.auditStatus,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.auditStatus) = $event)),
                            options: _unref(oaReviewStatus),
                            placeholder: _unref(t)('common.pleaseSelect'),
                            allowClear: "",
                            "show-arrow": ""
                          }, null, 8, ["value", "options", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.customerName')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: queryForm.customerName,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                            allowClear: "",
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.followerName')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            value: queryForm.seller,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.seller) = $event)),
                            placeholder: _unref(t)('common.pleaseSelect'),
                            allowClear: ""
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.customerNumber')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: queryForm.customerNumber,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.customerNumber) = $event)),
                            allowClear: "",
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.arkCode')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: queryForm.arkCode,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.arkCode) = $event)),
                            allowClear: "",
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.申请单号')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: queryForm.applyNo,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.applyNo) = $event)),
                            allowClear: "",
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.流程创建人')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            value: queryForm.applicant,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.applicant) = $event)),
                            placeholder: _unref(t)('common.pleaseSelect'),
                            allowClear: ""
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.流程创建时间')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosRangePicker, {
                            isOutputBeijingTime: "",
                            startTime: queryForm.startCreateTime,
                            "onUpdate:startTime": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.startCreateTime) = $event)),
                            endTime: queryForm.endCreateTime,
                            "onUpdate:endTime": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.endCreateTime) = $event))
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.客户创建时间')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosRangePicker, {
                            isOutputBeijingTime: "",
                            startTime: queryForm.startCustomerCreateTime,
                            "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.startCustomerCreateTime) = $event)),
                            endTime: queryForm.endCustomerCreateTime,
                            "onUpdate:endTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.endCustomerCreateTime) = $event))
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                bodyCell: _withCtx(({ column, record, text }) => [
                  (column.dataIndex === 'customerName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_router_link, {
                          class: "ant-table-cell-ellipsis",
                          to: `/ofbu/accountActivation/view?accountActivationId=${record.id}&cosId=${record.cosId}`,
                          title: text
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(text || '--'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title"])
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'nextReviewer')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString((record.nextReviewer&&record.nextReviewer.length>0)? record.nextReviewer.map(item => item.employeeName||'--').join('、'): '--'), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'auditStatus')
                    ? (_openBlock(), _createBlock(_component_dc_status, {
                        key: 2,
                        enums: statusEnum.value,
                        value: text
                      }, null, 8, ["enums", "value"]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'arkCode')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(Array.isArray(text) && text.length > 0 ? text.join('、') : '--'), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'action')
                    ? (_openBlock(), _createBlock(_component_MoreButton, { key: 4 }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                            type: "link",
                            onClick: ($event: any) => (handleAccountActivationDraft(record)),
                            disabled: record.auditStatus !== '10'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])), [
                            [_directive_permission, 'ofbu_account_activation_draft_edit_btn']
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                            type: "link",
                            onClick: ($event: any) => (handleAccountActivationSubmitReview(record)),
                            disabled: record.auditStatus !== '11'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.提交')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])), [
                            [_directive_permission, 'ofbu_account_activation_submit_review_btn']
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                            type: "link",
                            onClick: ($event: any) => (handleAccountActivationRecall(record)),
                            disabled: record.auditStatus !== '20'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.withdraw')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])), [
                            [_directive_permission, 'ofbu_account_activation_recall_btn']
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                            type: "link",
                            onClick: ($event: any) => (handleAccountActivationDelete(record)),
                            disabled: record.auditStatus === '20'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])), [
                            [_directive_permission, 'ofbu_account_activation_del_btn']
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "search"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})